import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

export default function HeroSection() {
  const mainArticle = featuredArticles[0];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {/* Background image */}
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20urban%20night%20scene%20with%20dramatic%20contrast%20lighting%2C%20abstract%20city%20lights%20blurred%20in%20background%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20no%20recognizable%20people%2C%20warm%20orange%20and%20deep%20charcoal%20tones%2C%20editorial%20photography%20style%20with%20strong%20contrast%20and%20moody%20vibe%2C%20perfect%20for%20entertainment%20news%20website%20hero%20background&width=1800&height=900&seq=hero-bg-51chigua&orientation=landscape"
        alt="51吃瓜网站——最新网红明星爆料八卦"
        title="51吃瓜网站——最新网红明星爆料八卦"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      {/* Content */}
      <div className="relative z-10 h-full flex items-end pb-12 md:pb-16 px-4 md:px-6">
        <div className="w-full max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
            {/* Left: main title */}
            <div className="flex-1 max-w-2xl">
              {/* Social proof */}
              <div className="flex items-center gap-2 mb-4">
                <div className="flex -space-x-2">
                  <div className="w-8 h-8 rounded-full border-2 border-white/30 overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Young%20Asian%20person%20casual%20portrait%2C%20simple%20clean%20background%2C%20warm%20natural%20lighting%2C%20friendly%20expression%2C%20neutral%20colors&width=64&height=64&seq=hero-avatar-1&orientation=squarish"
                      alt="吃瓜用户"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="w-8 h-8 rounded-full border-2 border-white/30 overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20casual%20portrait%2C%20simple%20clean%20background%2C%20warm%20natural%20lighting%2C%20friendly%20smile%2C%20neutral%20colors&width=64&height=64&seq=hero-avatar-2&orientation=squarish"
                      alt="吃瓜用户"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="w-8 h-8 rounded-full border-2 border-white/30 overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Young%20Asian%20man%20casual%20portrait%2C%20simple%20clean%20background%2C%20warm%20natural%20lighting%2C%20friendly%20expression%2C%20neutral%20colors&width=64&height=64&seq=hero-avatar-3&orientation=squarish"
                      alt="吃瓜用户"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <span className="text-white/80 text-sm">10w+ 吃瓜群众在线</span>
              </div>

              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight mb-4">
                <span className="font-black">最新爆料</span>
                <br />
                <span className="font-light">一手吃瓜</span>
              </h1>

              <Link
                to={`/article/${mainArticle.id}`}
                className="inline-flex items-center gap-2 bg-background-50 text-foreground-950 px-6 py-3 rounded-full font-medium text-sm hover:bg-accent-500 hover:text-background-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                立即开瓜
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            {/* Right: subtitle */}
            <div className="lg:w-80 hidden lg:block">
              <p className="text-white/60 text-sm leading-relaxed">
                聚合最新网红明星八卦、吃瓜爆料、黑料视频，一站式吃瓜平台。实时掌握网红明星塌房动态，做最懂瓜的吃瓜人。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}